import axios from "axios";

import { Invoice, InvoiceMaterialRaw } from "fe-shared-transactions/src/types";
import { RawInvoiceTransaction } from "fe-shared-transactions/src/types/invoice";
import { mapMaterialsWithUnits } from "fe-shared-transactions/src/helpers/mapMaterialsWithUnits";
import { getMappedTransactions } from "fe-shared-transactions/src/helpers/getMappedTransactions";

export const getInvoice = (queryKey: string, invoiceNumber: string) =>
  axios
    .get<Invoice>("invoices/rate", {
      params: { invoiceNumber },
    })
    .then(({ data }) => {
      const { transactions, unidentifiedMaterials, ...rest } = data;

      return {
        ...rest,
        transactions: getMappedTransactions(
          (transactions as unknown) as RawInvoiceTransaction[]
        ),
        unidentifiedMaterials: mapMaterialsWithUnits(
          (unidentifiedMaterials as unknown) as InvoiceMaterialRaw[]
        ),
      };
    });

export default {
  getInvoice,
};
